import PropTypes from 'prop-types'
// NOTE: Stateful: local state, not Redux state!

import React from 'react'
import cx from 'classnames'
import classes from './Sticky.scss'

import { Gateway } from 'react-gateway'

import mediaQueryMatches from 'helpers/mediaQuery'

export const Sticky = React.createClass({
  propTypes: {
    children: PropTypes.node,
    hideUnstuck: PropTypes.bool,
    media: PropTypes.oneOfType([ // defaults are set in handleResize
      PropTypes.string, // medium
      PropTypes.array // ['medium', 'max|min|both']
    ])
  },

  getDefaultProps: () => ({
    hideUnstuck: false
  }),

  getInitialState: function () {
    return { stuck: false }
  },

  componentDidMount: function () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },

  componentWillUnmount: function () {
    window.removeEventListener('resize', this.handleResize)
  },

  handleResize: function () {
    let breakpoint = this.props.media
    let type = 'both'

    if (!breakpoint) {
      breakpoint = ['medium', 'max']
    }

    if (Array.isArray(breakpoint)) {
      type = breakpoint[1] || type // NOTE: Assign first as we're reassigning breakpoint below!
      breakpoint = breakpoint[0]
    }

    const matches = mediaQueryMatches(breakpoint, type) // NOTE: Matches can be undefined, which means it had an error

    if (matches) {
      // set defaults if sticky isn't found
      if (!this._sticky) return (this.setState({ stuck: false }))

      this.setState({ stuck: true })
    } else {
      this.setState({ stuck: false })
    }
  },

  renderSticky: function () {
    const stickyClass = cx({
      [classes.sticky]: classes.sticky,
      [classes.stuck]: this.state.stuck && classes.stuck,
      [classes.hidden]: !this.state.stuck && this.props.hideUnstuck && classes.hidden
    })

    return <div className={stickyClass} ref={ref => (this._sticky = ref)}>
      {this.props.children}
    </div>
  },

  render: function () {
    if (this.state.stuck) { // place sticky into a gateway..
      return <Gateway into={`sticky`}>
        {this.renderSticky()}
      </Gateway>
    }

    return this.renderSticky()
  }
})

export default Sticky



// WEBPACK FOOTER //
// ./src/components/Sticky/Sticky.js